import logo from '../assets/images/logo.png';
import logo_small from '../assets/images/logo_small.PNG';
import check_icon from '../assets/images/check-icon.png';
import laptop_icon from '../assets/images/laptop.PNG'

import iot_cihaz from '../assets/images/ARGEIoTCihaz-icon.png'
import danismanlik from '../assets/images/danısmanlık-icon.png'
import mobile_apps from '../assets/images/MobileApps-icon.png'
import call_center from '../assets/images/OmniChannelCallCenterCozumleri-icon.png'
import veri_analizi from '../assets/images/VeriAnalizivePredictiveMaintenanceCozumleri-icon.png'
import web_arayuzu from '../assets/images/WebArayuzCozumleri-icon.png'
import wfm_cozumleri from '../assets/images/WFMCozumleri-icon.png'
import monte from '../assets/images/Monte-icon.png'
import mudahale from '../assets/images/Mudahale-icon.png'
import haber from '../assets/images/Haber-icon.png'
import faz_olcum from '../assets/images/3FazOlcum-icon.png';
import cift_sim_kart from '../assets/images/CiftSimKart-icon.png';
import yedek_pil from '../assets/images/FazGucKaynagiveYedekPil-icon.png';
import haberlesme from '../assets/images/HaberlesmeSecenekleri- icon.png';
import entegrasyon from '../assets/images/EntegrasyonuKabiliyeti-icon.png';
import zorlu_hava_kosullari from '../assets/images/ZorluHavaKosullarınaAzamiSeviyedeUyum-icon.png';
import number_one from '../assets/images/1-icon.png';
import number_two from '../assets/images/2-icon.png';
import number_three from '../assets/images/3-icon.png';
import number_four from '../assets/images/4-icon.png';
import number_five from '../assets/images/5-icon.png';
import number_six from '../assets/images/6-icon.png';

import telefon from '../assets/images/Telefon-icon.png';
import mail from '../assets/images/mail-icon.png';
import adres from '../assets/images/Adres-icon.png';
import main from '../assets/images/main.PNG'


export default {
    logo, logo_small, check_icon, laptop_icon,
    iot_cihaz, danismanlik, mobile_apps,
    call_center, veri_analizi, web_arayuzu, wfm_cozumleri,
    monte, mudahale, haber,
    faz_olcum, cift_sim_kart, yedek_pil, haberlesme, entegrasyon, zorlu_hava_kosullari,
    number_one, number_two, number_three, number_four, number_five, number_six,
    telefon, mail, adres, main
};